
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.272 45.674c-.26 0-.52-.1-.71-.289L11.374 32.254a.988.988 0 010-1.404.999.999 0 011.41 0l12.388 12.335L47.29 15.35a.993.993 0 011.4-.16c.43.34.51.966.16 1.394L26.042 45.296c-.18.219-.44.358-.73.378h-.04z"}})])
          )
        }
      }
    